import React, { useEffect, useState } from "react";
import { Box, TextField, Grid, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PrimaryButton } from "src/Shared/Buttons";
import ConfirmationModal from "../../../../Shared/ConfimationModal";

const RestMenuComp = ({ handleSnackbarOpen, classes }) => {
  const [csv, setCsv] = useState("");
  const [open, setOpen] = useState(false);
  const { id } = useParams();

  const exportMenuHandler = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}restaurant/menu/${id}/export`
      );
      if (data) {
        if (data?.res) {
          let base64String = Buffer.from(JSON.stringify(data.res)).toString(
            "base64"
          );
          let sourceText = `data:application/json;base64,${base64String}`;
          let link = document.createElement("a");
          let fileName = "menu.json";
          link.href = sourceText;
          link.download = fileName;
          link.click();
        }
      } else {
        handleSnackbarOpen("something went wrong!", "errorDark");
      }
    } catch (error) {
      console.log("error occured!", error);
      if (error?.response?.data?.error) {
        handleSnackbarOpen(error?.response?.data?.error, "errorDark");
      } else if (error?.message) {
        handleSnackbarOpen(error?.message, "errorDark");
      }
    }
  };
  const importMenuHandler = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}restaurant/menu/${id}/import`,
        csv
      );
      if (data) {
        if (data?.message) {
          handleSnackbarOpen(data?.message, "successDark");
        }
      } else {
        handleSnackbarOpen("Something went wrong!", "errorDark");
      }
    } catch (error) {
      console.log("this is error", error);
      if (error?.response?.data?.error) {
        handleSnackbarOpen(error?.response?.data?.error, "errorDark");
      } else if (error?.message) {
        handleSnackbarOpen(error?.message, "errorDark");
      }
      return;
    }
  };

  const onChangeHandler = (event) => {
    if (event?.target?.files?.length > 0) {
      setCsv(event.target.files[0]);
    } else {
      setCsv("");
    }
  };
  const openHandler = () => {
    if (typeof csv !== "string") {
      setOpen(true);
    }
  };
  return (
    <>
      <Grid container spacing={2} className={classes.mt30} direction="row">
        <Grid xs={12} item>
          <Typography variant="h5" className={classes.typographyStyles}>
            Restaurant Menu
          </Typography>
          <hr />
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4}>
              <TextField
                type="file"
                onChange={onChangeHandler}
                variant="outlined"
                size="small"
                name="csv"
                inputProps={{
                  accept: ".json",
                  "aria-label": "import_menu_input",
                }}
              />
            </Grid>
            <Grid xs={3}>
              <PrimaryButton
                testId="import_menu_btn"
                type="success"
                handleClick={openHandler}
              >
                Import Menu
              </PrimaryButton>
            </Grid>
            <Grid xs={5} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <PrimaryButton
            testId="export_menu_btn"
            type="success"
            handleClick={exportMenuHandler}
          >
            Export Menu
          </PrimaryButton>
        </Grid>
      </Grid>
      {open && (
        <ConfirmationModal
          open={open}
          content={`Are you sure to delete current restaurant menu and add new restaurant menu!`}
          deleteHandler={importMenuHandler}
          setIsopen={() => setOpen(false)}
          buttonName="Confirm Import"
        />
      )}
    </>
  );
};

export default RestMenuComp;
